export type OrderHistoryUi = {
  events: HistoryEventUi[];
  orderNumber: string;
};

export type HistoryEventUi = {
  id: string;
  title: string;
  subtitle: string;
};

export const initialState: OrderHistoryUi = {
  orderNumber: '0000',
  events: [],
};
